const bannerCarousels = document.querySelectorAll('.banner--carousel.swiper');

bannerCarousels.forEach(bannerCarousel => {
    new Swiper(bannerCarousel, {
        loop: true,
        autoplay: {
            delay: 7000,
        },
        autoHeight: false,
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
            el: '.banner--carousel .swiper-pagination',
        },
        navigation: {
            nextEl: '.banner--carousel .swiper-button-next',
            prevEl: '.banner--carousel .swiper-button-prev',
        },
    });
});
